import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

import { ToasterService } from '../../_services/toaster.service';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthenicationService} from '../../_services/authenication.service';
import { PricesService } from "../../_services/prices.service";

import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

@Component({
  selector: 'app-create-api-keys',
  templateUrl: './create-api-keys.component.html',
  styleUrls: ['./create-api-keys.component.css']
})
export class CreateApiKeysComponent implements OnInit {

  addAPIKeyForm: FormGroup;
  submitted = false;
  returnUrl: string;
  userdetaild: string;
  id = this.route.snapshot.params.id;

  constructor(private formBuilder: FormBuilder, private router: Router, private route: ActivatedRoute, private toaster: ToasterService, private authenicationService: AuthenicationService, private pricesService: PricesService, private spinnerService: Ng4LoadingSpinnerService) { }


  ngOnInit() {

    this.userdetaild = this.authenicationService.userDetails();
    if (!this.userdetaild) {
      this.router.navigate(['/login']);
    }
    if (!this.userdetaild || this.userdetaild['users_usertype'] == 'employee2') {
      this.router.navigate(['/']);
    }

    this.addAPIKeyForm = this.formBuilder.group({
      company_api_key: [{value: '', disabled: true}, [Validators.required]],
      company_name: ['', [Validators.required]],
    });

    if (this.id != undefined) {
      let payload = {
        id: this.id
      };
      this.getApiKeyById(payload);
    }


    this.returnUrl = this.route.snapshot.queryParams.returnUrl || '/';
  }

  get f() { return this.addAPIKeyForm.controls; }

  onSubmit() {
    this.submitted = true;
    this.spinnerService.show();
    // stop here if form is invalid
    if (this.addAPIKeyForm.invalid) {
      this.spinnerService.hide();
      return;
    }


    if (this.id == undefined) {
      const addPayload = {
        company_name: this.addAPIKeyForm.controls.company_name.value.toLowerCase(),
        company_api_key: this.addAPIKeyForm.controls.company_api_key.value,
        company_api_key_validity: '2025-12-31',
      };

      this.addApiKey(addPayload);
    }
    else{
      const editPayload = {
        company_name: this.addAPIKeyForm.controls.company_name.value.toLowerCase(),
        company_api_key: this.addAPIKeyForm.controls.company_api_key.value,
        id: this.id
      };

      this.editApiKey(editPayload);
    }

    // console.log('message',addPayload);

  }

  addApiKey(payload) {
    this.pricesService.addApiKey(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate([`/api-key-list`]);
          } else {
            this.spinnerService.hide();
            this.toaster.showError('Add API Key', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('Add API Key', error);
        });
  }

  editApiKey(payload) {
    this.pricesService.editApiKey(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            this.spinnerService.hide();
            this.router.navigate([`/api-key-list`]);
          } else {
            this.spinnerService.hide();
            this.toaster.showError('Edit API Key', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('Edit API Key', error);
        });
  }

  getApiKeyById(payload) {
    this.pricesService.getApiKeyById(payload)
      .subscribe(
        (data: any) => {
          if (data && data.ResponseCode === '200') {
            let apiList = data.Data;
            this.addAPIKeyForm.get('company_name').setValue(apiList.company_name);
            this.addAPIKeyForm.get('company_api_key').setValue(apiList.company_api_key);
          } else {
            this.toaster.showError('API Keys', data.ResponseMessage);
          }
        },
        error => {
          this.spinnerService.hide();
          this.toaster.showError('API Keys', error);
        });
  }

  generateUUID(){
    let d = new Date().getTime();

  	if( window.performance && typeof window.performance.now === "function" )
  	{
  		d += performance.now();
  	}

  	let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c)
  	{
  		let r = (d + Math.random()*16)%16 | 0;
  		d = Math.floor(d/16);
  		return (c=='x' ? r : (r&0x3|0x8)).toString(16);
  	});
    this.setApiKey(uuid);
  return uuid;
  }

  setApiKey(value) {
    this.addAPIKeyForm.get('company_api_key').setValue(value)
  }



}
